import { useTranslation } from "react-i18next";
import {
  Center,
  Tab, TabList, TabPanel, TabPanels, Tabs,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Page } from "../../components/Page";
import { Card } from "../../components/Card";
import { WithAuthorization } from "../../context";
import { SupplierCompanies } from "./components/SupplierCompanies";
import { SupplierUsers } from "./components/SupplierUsers";
import { ManufacturingOrSourcingLocations } from "./components/ManufacturingOrSourcingLocations";

function SupplierManagement() {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierManagement"
  });
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} isLazy>
          <Center>
            <TabList borderBottom="none" marginBottom={4}>
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.supplierCompanies")}</Tab>
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.supplierUsers")}</Tab>
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.manufacturingOrSourcingLocations")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <SupplierCompanies />
            </TabPanel>
            <TabPanel padding="0">
              <SupplierUsers />
            </TabPanel>
            <TabPanel padding="0">
              <ManufacturingOrSourcingLocations />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  );
}

export default WithAuthorization(SupplierManagement);